import { SearchQueryRequestType } from '../../common/types';
import { usePostFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

import { ProjectType } from './ProjectsTable.types';

export type FetchProjectsResponseType = {
  count: number;
  results: ProjectType[];
};

export const useSearchProjects = (payload?: SearchQueryRequestType) => {
  const url = payload ? pathToUrl(ApiRoutesEnum.searchProjects) : '';
  return usePostFetch<FetchProjectsResponseType>(url, payload);
};
